import { useIqamaStore } from '../state/storeIqamaDelay';

export const useGetMetaIqama = () => {
	const updateIQFajr = useIqamaStore( ( state ) => state.updateIQFajr );
	const updateIQDhuhr = useIqamaStore( ( state ) => state.updateIQDhuhr );
	const updateIQAsr = useIqamaStore( ( state ) => state.updateIQAsr );
	const updateIQMaghrib = useIqamaStore( ( state ) => state.updateIQMaghrib );
	const updateIQIsha = useIqamaStore( ( state ) => state.updateIQIsha );
	const iqamaMetaUpdate = ( meta ) => {
		if ( meta[ 'meta-key' ] === 'IQFajr' ) {
			updateIQFajr( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'IQDhuhr' ) {
			updateIQDhuhr( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'IQAsr' ) {
			updateIQAsr( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'IQMaghrib' ) {
			updateIQMaghrib( JSON.parse( meta.value.toString() ) );
		}
		if ( meta[ 'meta-key' ] === 'IQIsha' ) {
			updateIQIsha( JSON.parse( meta.value.toString() ) );
		}
	};
	return { iqamaMetaUpdate };
};
